/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

//分类品牌
exports.getServcCatBrandListByCatId = function (params, callback) {// 根据分类id获取分类品牌列表
    api.post('/servc/categ/brand/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

//服务分类tree
exports.getServcCatTreeList = function (params, callback) {// 获取服务分类树形列表
    api.post('/servc/categ/tree/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
//服务分类tree
exports.getServcCatTreeListByFilter = function (params, callback) {// 获取服务分类树形列表
    api.post('/servc/categ/tree/list/get/by/filter')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 根据父id获取分类信息
exports.getServcCatListByParentId = function (params, callback) {
    api.post('/servc/categ/list/get/by/parentId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 根据父id获取分类信息
exports.getMerchtFusedGoodsCatByCatIds = function (params, callback) {
    api.post('/servc/categ/mercht/fused/servc/cat/list/get/by/servc/or/goodsCatId/or/goodsId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// ================ 评价 ====================

// 获取标签
exports.getServcCatEvalTagList = function (postData, callback) {// 获取评价标签列表
    api.post('/servc/categ/eval/tag/list/get')
    .data(postData)
    .done(callback)
    .go();
};
export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/servcCateg.js
// module id = 161
// module chunks = 0